<app-form-user
    [userListDelegate]="userListDelegate"
    [groupListBase]="groupListBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-user>
